import { useGame } from './hooks/useGame';
import { useFullscreen } from './hooks/useFullscreen';
import { playSound, resumeAudio } from './services/audio';
import { SplashScreen } from './components/SplashScreen';
import { IntroScreen } from './components/IntroScreen';
import { SetupScreen } from './components/SetupScreen';
import { GameBoard } from './components/GameBoard';

export function App() {
  const { state, dispatch } = useGame();
  const toggleFullscreen = useFullscreen();

  const playSfx = (type: 'click' | 'flip' | 'match' | 'steal' | 'start') =>
    playSound(type, state.soundEnabled);

  if (state.phase === 'splash') {
    return (
      <SplashScreen
        onStart={() => {
          resumeAudio();
          playSfx('start');
          dispatch({ type: 'SPLASH_DONE' });
        }}
        onToggleFullscreen={toggleFullscreen}
      />
    );
  }

  if (state.phase === 'intro') {
    return <IntroScreen state={state} dispatch={dispatch} onPlaySfx={playSfx} />;
  }

  if (state.phase === 'setup') {
    return <SetupScreen state={state} dispatch={dispatch} onPlaySfx={playSfx} />;
  }

  // playing 與 finished 都用 GameBoard（finished 透過 modalType='winner' 顯示 WinScreen overlay）
  return (
    <GameBoard
      state={state}
      dispatch={dispatch}
      onPlaySfx={playSfx}
      onToggleFullscreen={toggleFullscreen}
    />
  );
}
